import Repository from "@/services/repository";

export default {
  refreshData(studyId, keywordId) {
    return Repository.post(
      `/a/${studyId}/keywords/${keywordId}/refresh_data.json`
    ).then((response) => response);
  },
};
